const AppReducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR_ITEMS':
      return {
        activeProfile: {},
      };
    case 'SET_PROFILE':
      return {
        activeProfile: action.payload,
      };
    default:
      return state;
  }
};

export default AppReducer;
